module.exports = __webpack_public_path__ + "static/img/101843.520bdb34.png";